// extracted by mini-css-extract-plugin
export default {"hamburger":"SOIoya","hamburger-inner":"e90fX4","hamburgerInner":"e90fX4","hideOnMobile":"NiqGVr","hamburger-box":"DlihOv","hamburgerBox":"DlihOv"};